import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router";
import router from "./router/routes";
import { AuthProvider } from "./components/AuthProvider";
import { StoreProvider } from "./components/StoreProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import { initializeSentry } from "./lib/sentry";
import { initMixpanel } from "./lib/mixpanel";
import { patchDomForBrowserTranslate } from "./lib/patchDomForBrowserTranslate";
import { VibeKanbanWebCompanion } from "vibe-kanban-web-companion";
// Initialize Sentry before rendering the app
initializeSentry();
initMixpanel();
// Allow browser auto-translate without React removeChild/insertBefore crashes
patchDomForBrowserTranslate();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <StoreProvider>
          <RouterProvider router={router} />
          <VibeKanbanWebCompanion />
        </StoreProvider>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>
);
